module.exports = __webpack_public_path__ + "img/lodd-little.fa49d7a2.png";